import { Perfil } from './../../model/perfil';
import { Component, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { UploadInput, UploaderOptions, UploadFile, UploadOutput, UploadStatus, humanizeBytes } from 'ngx-uploader';
import { PerfilService } from '../../service/perfil/perfil.service';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { PasswordValidator } from '../../validators/PasswordValidator';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements AfterViewInit {
  emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  perfil: Perfil = new Perfil();
  buttonText = "Criar Perfil";
  tipoPerfilOptions: any;
  selectedPerfil: any;
  options: UploaderOptions;
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  fileName: String = "Buscar imagem .jpg ou .png";
  @ViewChild('fileInput') fileInput: ElementRef;

  perfilFormGroup: FormGroup;
  alterandoSenha: boolean;
  backupSenha: string;
  backupConfirmarSenha: string;


  constructor(private perfilService: PerfilService,
    private activatedRoute: ActivatedRoute,
    private route: Router,
    private formBuilder: FormBuilder) {
    this.options = { concurrency: 1, maxUploads: 1, allowedContentTypes: ['image/jpeg', 'image/jpg', 'image/png'] };
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;


    this.perfilFormGroup = this.formBuilder.group({
      nome: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ['', Validators.required],
      repeatPassword: ['', Validators.required],
      is_Rpl: ['', Validators.required]
    }, {
        validator: PasswordValidator.validate.bind(this)
      });
  }

  ngAfterViewInit() {
    this.LoadPerfil();
  }

  config = {
    displayKey: "nivel",
    search: false
  }

  public LoadTipoPerfil() {
    var user = JSON.parse(localStorage.getItem("idUser"));
    this.perfilService.OnSearchTipoPerfil(user["is_Ressarcimento"]).subscribe((res) => {
      this.tipoPerfilOptions = res;
      if (!this.perfil.tp_Nivel_Master && this.perfil.is_Rus > 0)
        this.perfilFormGroup.controls.is_Rpl.disable();
      else
        this.perfilFormGroup.controls.is_Rpl.enable();
    })
  }

  public LoadPerfil() {
    this.activatedRoute.params.subscribe(param => {
      if (param.id) {
        this.perfilService.GetPerfil(param.id).subscribe((res: Perfil) => {
          if (res) {
            this.perfil = res;
            this.perfilFormGroup.controls.repeatPassword.setValue(res.nm_Senha);
            this.buttonText = "Atualizar Perfil";
            this.LoadTipoPerfil();
          }
        });
      } else {
        this.LoadTipoPerfil();
      }
    });
  }

  onPasswordChange() {
    this.alterandoSenha = true;
    this.backupSenha = "";
    this.backupConfirmarSenha = "";
  }

  onPasswordFocus() {
    this.backupSenha = this.perfil.nm_Senha;
    this.backupConfirmarSenha = this.perfilFormGroup.controls.repeatPassword.value;
    this.perfil.nm_Senha = "";
    this.perfilFormGroup.controls.repeatPassword.setValue("");
  }

  onPasswordBlur() {
    if (this.backupSenha) {
      this.perfil.nm_Senha = this.backupSenha;
    }

    if (this.backupConfirmarSenha) {
      this.perfilFormGroup.controls.repeatPassword.setValue(this.backupConfirmarSenha);
    }

  }

  onButtonCreateUpdateClick() {
    this.perfilService
      .CreateOrUpdate(this.perfil, 1)
      .subscribe((res) => {
        if (res["statusRetorno"] > 0) {
          this.perfil.is_Rus = res["statusRetorno"];
          this.route.navigate(["/gerencia"]);
        }
      });
  }


  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {

      const event: UploadInput = {
        type: 'uploadAll',
        url: '/api/perfil/upload',
        method: 'POST'
      };
      this.uploadInput.emit(event);

    }

    else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {

      this.files.push(output.file);
      this.fileName = output.file.name;

    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      console.log(output.file.name + ' rejected');
    }

    this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);
  }

  startUpload(): void {
    this.fileInput.nativeElement.click();
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

}
